import { render, staticRenderFns } from "./FourByThreeCrop.vue?vue&type=template&id=9edb9b86&scoped=true&"
import script from "./FourByThreeCrop.vue?vue&type=script&lang=ts&"
export * from "./FourByThreeCrop.vue?vue&type=script&lang=ts&"
import style0 from "./FourByThreeCrop.vue?vue&type=style&index=0&id=9edb9b86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edb9b86",
  null
  
)

export default component.exports